import {
  Modal,
  Box,
  Typography,
  TextField,
  IconButton,
  FormControl,
  Button,
  Grid,
} from "@mui/material"
import SingleSelect from "@/components/Select/SingleSelect"

import { z } from "zod"
import { useAddModel } from "@/hooks/useAddModel"
import ClearIcon from "@mui/icons-material/Clear"
import { useEffect } from "react"
import { zodResolver } from "@hookform/resolvers/zod"
import { useCustomForm } from "@/hooks/useCustomForm"
import { useOrderCrudContext } from "@/context/orderCrudContext"

const CustomerReturnsSchema = z.object({
  gender: z.string().min(3),
  reason: z.string(),
})

const genderOptions = [
  { id: "male", name: "Male" },
  { id: "female", name: "Female" },
  { id: "other", name: "Other" },
]

const AddCustomerReturnsModel = ({
  open,
  onClose,
  defaultValues = {},
  getNewRecord,
}) => {
  const {
    errors,
    openDialog,
    isSubmitting,
    selectedRow,
    register,
    handleSubmit,
    onSubmit,
    handleReset,
    setValue,
    Controller,
    control,
    defaultOnClose,
  } = useAddModel("customer-returns", CustomerReturnsSchema)

  return (
    <Modal open={open ? open : openDialog} onClose={defaultOnClose}>
      <div className="w-[95vw] sm:w-[90vw] md:w-[500px] mx-auto mt-24 bg-white rounded-lg shadow-md">
        {/* Header */}
        <div className="flex items-center justify-between bg-[#f6f7f9] px-4 py-3 rounded-t-lg">
          <h2 className="font-semibold text-black text-[16px] md:text-[18px]">
            {selectedRow ? "Update Footfall" : "Add Footfall"}
          </h2>
          <IconButton
            aria-label="remove"
            size="small"
            onClick={onClose ? onClose : defaultOnClose}
          >
            <ClearIcon />
          </IconButton>
        </div>

        {/* Form Body */}
        <form onSubmit={handleSubmit(onSubmit)} noValidate className="p-4">
          {/* Gender Dropdown */}
          <div className="mb-4">
            <SingleSelect
              name="gender"
              controller={Controller}
              control={control}
              label="Gender"
              selectedValue={selectedRow?.gender ?? ""}
              options={genderOptions}
              error={!!errors.gender}
              helperText={errors.gender?.message}
              optionLabel="name"
              optionValue="id"
            />
          </div>

          {/* Reason Input */}
          <div className="mb-4">
            <TextField
              fullWidth
              label="Reason"
              error={!!errors.reason}
              helperText={errors.reason?.message?.toString()}
              {...register("reason")}
            />
          </div>

          {/* Action Buttons */}
          <div className="flex justify-end items-center gap-2 flex-wrap mt-2">
            <Button
              onClick={handleReset}
              variant="text"
              className="capitalize rounded-md font-medium text-[13px] py-[11px] px-[30px] w-full sm:w-auto"
            >
              Reset
            </Button>

            <Button
              onClick={onClose ? onClose : defaultOnClose}
              variant="outlined"
              color="error"
              className="capitalize rounded-md font-medium text-[13px] py-[11px] px-[30px] w-full sm:w-auto"
            >
              Cancel
            </Button>

            <Button
              type="submit"
              disabled={isSubmitting}
              variant="contained"
              className="capitalize rounded-md font-medium text-[13px] py-[11px] px-[30px] text-white w-full sm:w-auto"
            >
              {selectedRow ? "Update" : "Create"}
            </Button>
          </div>
        </form>
      </div>
    </Modal>
  )
}

export default AddCustomerReturnsModel
